import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { MoreHorizontal } from 'lucide-react';
import { pillSecondary } from '../ui/pills';

/**
 * Menu « Plus » de la barre du livre : les actions de second plan (résumé, impression, colonnes, disponibilités, réglages, plan de salle) rangées
 * derrière UN bouton, pour que l'écran d'arrivée ne montre que l'essentiel. Clavier : Entrée ouvre, Échap ferme, le clic ailleurs ferme.
 */
export interface EntreeMenu { label: string; icone?: React.ReactNode; onClick?: () => void; to?: string; separe?: boolean }

export const MenuPlus: React.FC<{ entrees: EntreeMenu[] }> = ({ entrees }) => {
    const [ouvert, setOuvert] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!ouvert) return undefined;
        const clic = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOuvert(false); };
        const touche = (e: KeyboardEvent) => { if (e.key === 'Escape') setOuvert(false); };
        document.addEventListener('mousedown', clic); document.addEventListener('keydown', touche);
        return () => { document.removeEventListener('mousedown', clic); document.removeEventListener('keydown', touche); };
    }, [ouvert]);
    const classe = 'w-full flex items-center gap-2.5 text-left px-3.5 h-11 text-[13px] font-semibold text-content hover:bg-surface-soft';
    return (
        <div ref={ref} className="relative">
            <button type="button" aria-haspopup="menu" aria-expanded={ouvert} onClick={() => setOuvert((o) => !o)} className={`${pillSecondary(36)} max-lg:!h-11`}><MoreHorizontal size={16} aria-hidden="true" />Plus</button>
            {ouvert && (
                <div role="menu" className="absolute right-0 top-full mt-1 z-30 min-w-[240px] rounded-xl border border-border bg-surface shadow-lg py-1">
                    {entrees.map((e) => (
                        <React.Fragment key={e.label}>
                            {e.separe && <div role="separator" className="my-1 border-t border-border-soft" />}
                            {e.to
                                ? <Link role="menuitem" to={e.to} className={classe} onClick={() => setOuvert(false)}>{e.icone}{e.label}</Link>
                                : <button type="button" role="menuitem" className={classe} onClick={() => { setOuvert(false); e.onClick?.(); }}>{e.icone}{e.label}</button>}
                        </React.Fragment>
                    ))}
                </div>
            )}
        </div>
    );
};
